import Fancybox from "../../../src/js/shared/fancybox";

'use strict';

const $ = jQuery.noConflict();
$(function() {
	const work = {
		init: function() {
			this.classAddition();
			this.initFancybox();
		},

		classAddition: function() {
			const work = $('.js-team__members');
			if (work.length > 0) {
				const projectCount = work.find('.team__member').length;

				if (projectCount < 4) {
					work.addClass('team__left-center');
				}
			}
		},

		initFancybox: function() {
			$('.popup-btn').on('click', function(e) {
				e.preventDefault();
				const popupKey = $(this).data('popup');
				const $popupContent = $('[data-popup-content="' + popupKey + '"]').clone().show();
				$.fancybox.open($popupContent, {
					smallBtn: true,
					baseClass: 'team-popup-fancybox',
					clickSlide: 'close',
					clickOutside: 'close',
					preventScroll: true
				});
			});
		}
	};

	work.init();
});
